import {Box, Typography} from '@mui/material';

import {WorkforceCulturalAlignmentLegendBadge} from './WorkforceCulturalAlignmentLegendBadge';
import {COMPANY_MARKER_COLOR, PROFILE_MARKER_COLOR} from '../../../utils/WorkforceProfileDetail/workforceCulturalAlignmentUtils';

export interface Props {
  title: string;
  companyLabel: string;
  profileLabel: string;
}

export const WorkforceCulturalAlignmentLegend = ({title, companyLabel, profileLabel}: Props) => (
  <Box sx={{display: 'flex', alignItems: 'center', gap: 2, mb: 1.5, flexWrap: 'wrap'}}>
    <Typography
      sx={{
        fontSize: 13,
        fontWeight: 500,
        color: 'text.secondary',
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
      }}
    >
      {title}
    </Typography>
    <Box sx={{display: 'flex', gap: 1.25, ml: {xs: 0, sm: 'auto'}}}>
      <WorkforceCulturalAlignmentLegendBadge color={COMPANY_MARKER_COLOR} label={companyLabel} />
      <WorkforceCulturalAlignmentLegendBadge color={PROFILE_MARKER_COLOR} label={profileLabel} />
    </Box>
  </Box>
);
